import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsEllipsisIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 19 5" {...props}>
    <g>
      <path
        d="M 5.00,2.50
           C 5.00,3.88 3.88,5.00 2.50,5.00
             1.12,5.00 0.00,3.88 0.00,2.50
             0.00,1.12 1.12,0.00 2.50,0.00
             3.88,0.00 5.00,2.50 5.00,2.50 Z
           M 12.00,2.50
           C 12.00,3.88 10.88,5.00 9.50,5.00
             8.12,5.00 7.00,3.88 7.00,2.50
             7.00,1.12 8.12,0.00 9.50,0.00
             10.88,0.00 12.00,2.50 12.00,2.50 Z
           M 19.00,2.50
           C 19.00,3.88 17.88,5.00 16.50,5.00
             15.12,5.00 14.00,3.88 14.00,2.50
             14.00,1.12 15.12,0.00 16.50,0.00
             17.88,0.00 19.00,2.50 19.00,2.50 Z"
      />
    </g>
  </StyledIcon>
)

CsEllipsisIcon.displayName = 'CsEllipsisIcon'
